// extracted by mini-css-extract-plugin
module.exports = {"timeSelect":"heP1e","skills":"M7SDx","overdue":"XB0ex","selectDescription":"_2qmLd"};